<template>
  <div>
    
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data() {
    return {};
  },

  created() {
  },

  mounted() {
  },

  methods: {}
};
</script>





// WEBPACK FOOTER //
// 200.vue?2d4a2930